var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M20.69,8a10.42,10.42,0,0,0-1.76-3.73L15.2,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M18.93,16.73A10.42,10.42,0,0,0,20.69,13H15.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M13,20.69a10.42,10.42,0,0,0,3.73-1.76L13,15.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M4.27,18.93A10.42,10.42,0,0,0,8,20.69V15.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M8,.31A10.42,10.42,0,0,0,4.27,2.07L8,5.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M16.73,2.07A10.42,10.42,0,0,0,13,.31V5.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M2.07,4.27A10.42,10.42,0,0,0,.31,8H5.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    className: "a",
    d: "M.31,13a10.42,10.42,0,0,0,1.76,3.73L5.8,13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "b",
    d: "M13,13v.9l4.45,4.45a9.56,9.56,0,0,0,.9-.9L13.9,13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "b",
    d: "M8,7.08,3.58,2.61a9.56,9.56,0,0,0-.9.9L7.12,8H8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "b",
    d: "M13.92,8l4.47-4.42a9.56,9.56,0,0,0-.9-.9L13,7.12V8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "b",
    d: "M7.08,13,2.61,17.42a9.56,9.56,0,0,0,.9.9L8,13.88V13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    className: "b",
    d: "M20.88,9H12V.12A10.59,10.59,0,0,0,10.5,0,10.59,10.59,0,0,0,9,.12V9H.12A10.59,10.59,0,0,0,0,10.5,10.59,10.59,0,0,0,.12,12H9v8.88a10.59,10.59,0,0,0,1.5.12,10.59,10.59,0,0,0,1.5-.12V12h8.88A10.59,10.59,0,0,0,21,10.5,10.59,10.59,0,0,0,20.88,9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "c",
    d: "M8.5.2,8,.31V5.8L4.27,2.07c-.13.09-.26.18-.38.28s-.21.18-.31.26L8,7.08V8H7.12L2.68,3.51c-.11.12-.23.25-.33.38s-.19.25-.28.38L5.8,8H.31c0,.17-.08.33-.11.5A4,4,0,0,0,.12,9H9V.12A4,4,0,0,0,8.5.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "c",
    d: "M8.09,12h-8a4,4,0,0,0,.08.5c0,.17.07.33.11.5H5.8L2.07,16.73c.09.13.18.26.28.38s.18.21.26.31L7.08,13H8v.88L3.51,18.32c.12.11.25.23.38.33s.25.19.38.28L8,15.2v5.49l.5.11a4,4,0,0,0,.5.08V12Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "c",
    d: "M14.2,12H12v8.88a4,4,0,0,0,.5-.08l.5-.11V15.2l3.73,3.73c.13-.09.26-.18.38-.28s.23-.2.34-.3L13,13.9V13h.9l4.45,4.45c.1-.11.21-.22.3-.34s.19-.25.28-.38L15.2,13h5.49c0-.17.08-.33.11-.5a4,4,0,0,0,.08-.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "c",
    d: "M20.8,8.5c0-.17-.07-.33-.11-.5H15.2l3.73-3.73c-.09-.13-.18-.26-.28-.38s-.18-.21-.26-.31L13.92,8H13V7.12l4.49-4.44c-.12-.11-.25-.23-.38-.33s-.25-.19-.38-.28L13,5.8V.31L12.5.2A4,4,0,0,0,12,.12V9h8.88A4,4,0,0,0,20.8,8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b21694dfbc5e6b269e4c5d80c5b2c117.svg";
export { ForwardRef as ReactComponent };